import { Subject } from "rxjs";

const ErrorSubject = new Subject();

export { ErrorSubject };



// WEBPACK FOOTER //
// ./src/shared/ErrorSubject.js